import { createApp, Component, ComponentCustomProperties, App as VueApp } from "vue";

declare module "vue" {
  interface ComponentCustomProperties {
    $map: any; // 地图对象
  }
}

let root: ComponentCustomProperties;
let app: VueApp;

export function createInstance(App: Component): VueApp {
  app = createApp(App);
  root = app.config.globalProperties as ComponentCustomProperties;
  return app;
}

export function getRoot(): ComponentCustomProperties {
  return root;
}

export function getApp(): VueApp {
  return app;
}
